import { Injectable } from '@angular/core';

@Injectable()

export class GAService {

  trackMe(what: any) {
    //gtag('event', what, {
    //  'event_category': 'BUTTON_CLICK',
    //  'event_label': 'Track Me Click',
    //  'value': 0
    //})
  }

}
